import { FormType } from '../../../form-types';
import { PCOSInitialQuestionFieldAnswers } from './questions';

export const pcos: FormType<PCOSInitialQuestionFieldAnswers> = {
  name: 'PCOS',
  questions: [
    'pcos_readyToStart',
    {
      key: 'pcos_diagnosedWithPcos',
      next: {
        condition: { 'pcos_diagnosedWithPcos.diagnosed': true },
        key: 'pcos_primaryReason',
        els: 'pcos_ineligible'
      }
    },
    {
      key: 'pcos_primaryReason',
      next: {
        condition: { 'pcos_primaryReason.other': true },
        key: 'pcos_primaryReasonOther',
        els: 'pcos_symptoms'
      }
    },
    'pcos_primaryReasonOther',
    'pcos_symptoms',
    'pcos_weightHeightBMI',
    {
      key: 'pcos_sexAssignedAtBirth',
      next: {
        condition: { 'pcos_sexAssignedAtBirth.female': true },
        key: 'pcos_pregnancy',
        els: 'pcos_ineligible'
      }
    },
    {
      key: 'pcos_pregnancy',
      next: {
        condition: { 'pcos_pregnancy.yes': true },
        key: 'pcos_ineligible',
        els: 'pcos_pregnancyConsent'
      }
    },
    {
      key: 'pcos_pregnancyConsent',
      next: {
        condition: { 'pcos_pregnancyConsent.non_consent': true },
        key: 'pcos_ineligible',
        els: 'pcos_hasUterus'
      }
    },
    {
      key: 'pcos_hasUterus',
      next: {
        condition: { 'pcos_hasUterus.yes': true },
        key: 'pcos_cyclePattern',
        els: 'pcos_hormoneTherapyHistory'
      }
    },
    'pcos_cyclePattern',
    'pcos_cyclesPerYear',
    'pcos_lastMenstrualPeriod',
    'pcos_hormoneTherapyHistory',
    {
      key: 'pcos_progesteroneExperience',
      next: {
        condition: { 'pcos_progesteroneExperience.side_effect': true },
        key: 'pcos_progesteroneSideEffects',
        els: 'pcos_progesteroneContraindications'
      }
    },
    'pcos_progesteroneSideEffects',
    'pcos_progesteroneContraindications',
    {
      key: 'pcos_usedGlp1',
      next: {
        condition: { 'pcos_usedGlp1.yes': true },
        key: 'pcos_glp1Medication',
        els: 'pcos_glp1Considerations'
      }
    },
    'pcos_glp1Medication',
    {
      key: 'pcos_glp1SideEffects',
      next: {
        condition: { 'pcos_glp1SideEffects.yes': true },
        key: 'pcos_glp1SideEffectsDetails',
        els: 'pcos_glp1Considerations'
      }
    },
    'pcos_glp1SideEffectsDetails',
    {
      key: 'pcos_glp1Considerations',
      next: {
        switch: [
          {
            condition: {
              'pcos_glp1Considerations.current_gallstones_without_symptoms':
                true
            },
            key: 'pcos_gallstonesConsent'
          },
          {
            condition: {
              'pcos_glp1Considerations.past_gallbladder_removal': true
            },
            key: 'pcos_cholecystectomyConsent'
          },
          {
            condition: {
              'pcos_glp1Considerations.liver_failure_cirrhosis': true
            },
            key: 'pcos_ineligible'
          },
          {
            condition: {
              'pcos_glp1Considerations.ckd_stage_3b_or_greater': true
            },
            key: 'pcos_ineligible'
          }
        ],
        els: 'pcos_glp1ProductAllergy'
      }
    },
    {
      key: 'pcos_gallstonesConsent',
      next: {
        switch: [
          {
            condition: { 'pcos_gallstonesConsent.non_consent': true },
            key: 'pcos_ineligible'
          },
          {
            condition: {
              'pcos_glp1Considerations.past_gallbladder_removal': true
            },
            key: 'pcos_cholecystectomyConsent'
          }
        ],
        els: 'pcos_glp1ProductAllergy'
      }
    },
    'pcos_cholecystectomyConsent',
    'pcos_glp1ProductAllergy',
    'pcos_interactingMeds',
    'pcos_otherInformation',
    "pcos_medicationConsent",
    'pcos_complete',
    'pcos_ineligible'
  ]
};
